import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['getUsername', 'userID']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    savitarnaParams() {
      return this.isLocal
        ? ''
        : `?xid=${this.$route.query.xid}&enc=${this.$route.query.enc}`
    },
    savitarnaPrefix() {
      return this.isLocal ? '' : '/ntrpaslaugos'
    },
    menuData() {
      return `<?xml version="1.0" encoding="utf-8"?>
      <!DOCTYPE html
        PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
      <html xmlns="http://www.w3.org/1999/xhtml" xml:lang="lt" lang="lt">

      <head>
        <meta http-equiv="content-type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <script type="text/javascript" nonce="9e4be938-b606-4b3a-94cb-3f075599d9c4" async
          src="https://www.googletagmanager.com/gtag/js?id=G-3G6H5V13LC"></script>
        <script type="text/javascript" nonce="9e4be938-b606-4b3a-94cb-3f075599d9c4"
          src="https://appdevel4.kada.lt/savitarna/javascripts/cookieconsent.min.js" data-cfasync="false"></script>
        <script type="text/javascript" nonce="9e4be938-b606-4b3a-94cb-3f075599d9c4"
          src="https://appdevel4.kada.lt/savitarna/javascripts/gdpr_savitarna.js"></script>

        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/style.css" type="text/css" />
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/components.css" type="text/css" />
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/new/components.css" type="text/css" />
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/print.css" type="text/css" media="print" />
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/print-modal.css" type="text/css" />
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/cookieconsent.min.css" type="text/css" />

        <!-- Pridėti pagal tab spalvą -->
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/dark-blue.css" type="text/css" />
        <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/new/dark-blue.css" type="text/css" />

        <title>VĮRC Savitarna</title>

      </head>
      <body>

      <div id="info-panel">
          <div class="user-info">
          ${this.userID} ${this.getUsername}

          </div>

          <div class="site-info" style="width:300px;">
            <a id="sav_logout" class="logout" href="/login">Baigti darbą</a>

            <a href="javascript:Neigal()">
                <img src="https://w2dev.kada.lt/savitarna/images/icn-disa.png" height="10" alt="Neįgaliųjų versija"
                     class="neigal" style="border-color: rgb(0, 0, 0); color: rgb(0, 0, 0); margin-left: 5px;">
            </a>

            <a class="localeEN" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=350&lang=en

      "> EN </a>

            <a class="localeLT" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=350&lang=lt

      "> LT </a>

            <style>
              .localeLT {
                padding: 0 0 4px;
                margin-left: 8px;
                color: #000000;
                font-weight: bold;
              }

            </style>
          </div>
        </div>
        <div id="container-in">
          <div id="header-in">
            <div class="logo-container">
              <ul>
                <li>
                  <a id="sav_rcLogo1" href="/">
                    <img id="rcLogo1" src="/static/RC_LOGO_1.png"  alt="" border="0" />
                  </a>
                </li>
                <li>
                  <a id="sav_rcLogo2" href="/">
                    <img id="rcLogo2" src="/static/RC_LOGO_2.png"  alt="" border="0" />
                  </a>
                </li>
              </ul>
            </div>
            <div class="new-cart-container" style="width: 125px;">
              <img src="/static/new_user_ico.gif" alt="Mano pirkimai" border="0" />

              <div>
                <a id="sav_purchases" href="

              https://appdevel4.kada.lt/savitarna/myData.do

      ">Mano pirkimai</a><br />
                Mokėjimai, istorija
              </div>
            </div>
            <div class="new-cart-container" style="width: 155px;">
              <img src="/static/new_cart_ico.gif" alt="Krepšelis" border="0" />

              <div>
                <a id="sav_basket" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=13

      ">
                  Krepšelis
                  (0)
                </a><br />
                0.00 €
              </div>
            </div>

            <div class="new-cart-container" style="width: 275px;">
              <img src="/static/money.png" alt="Avansas" border="0" />

              <div style="margin-top: 5px;">
                <a id="sav_advance" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=115

      ">
                  Avansas
                </a><br />
              </div>
              <div>
                Likutis - 0.00 €</br> Rezervuota - 0.00 €
              </div>
            </div>

            <ul class="main-tabs">

              <li class=" active">
                <a>
                  <span style="width: 103px;" class="sv-savitarna"></span>
                </a>
              </li>

            </ul>
            <div class="tabs-container">
              <ul class="tabs">
                <li class="">
                  <a id="sav_menu_NTR" class="ntr" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=4

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>

                <li class="">
                  <a id="sav_menu_JAR" class="jar" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=23

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>

                <li class="">
                  <a id="sav_menu_AR" class="ar" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=3

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>

                <li class="">
                  <a id="sav_menu_SERTIFIKATU_CENTRAS" class="sc" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=2

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>

                <li class="">
                  <a id="sav_menu_GR" class="gr" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=6

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>

                <li class="">
                  <a id="sav_menu_IR" class="ir" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=5

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>
                <li class="active">
                  <a id="sav_menu_STSR" class="stsr" href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=7

      ">
                    <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                  </a>
                </li>
              </ul>
              <div class="tabs-right"></div>
            </div>
          </div>

          <div id="content-in">
          <div class="left">
          local menu
            <ul class="side-menu">
              <li>
                <a  href="${this.savitarnaPrefix}/paslaugos${this.savitarnaParams}">
                  Paslaugos
                </a>
              </li>
              <li>
                <a  href="${this.savitarnaPrefix}/pranesimai${this.savitarnaParams}">
                  Gauti pranešimai
                </a>
              </li>
              <li>
                <a  href="${this.savitarnaPrefix}/dokumentai${this.savitarnaParams}">
                  Mano dokumentai
                </a>
              </li>
              <li>
                <a class=" " href="${this.savitarnaPrefix}/paieska${this.savitarnaParams}">
                  Paieškos
                </a>
              </li>

              <li><a class=" " href="${this.savitarnaPrefix}/ntr-paslaugos/prasymai${this.savitarnaParams}">Prašymai dėl juridinių faktų</a>

              <ul>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/dokumentai${this.savitarnaParams}">
              Dokumentų sąrašas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/pranesimai${this.savitarnaParams}">
              Gauti pranešimai
              </a></li>

              <li><a class=" " href="${this.savitarnaPrefix}/ntr-paslaugos/pazyma/zemes-sklypas${this.savitarnaParams}">
                Žemės sklypo planas
              </a></li>

              <li><a class=" " href="${this.savitarnaPrefix}/ntr-paslaugos/pazyma${this.savitarnaParams}">
                Pažyma apie ŽŪ / MŪ paskirties žemes
              </a></li>

              <li><a class=" " href="${this.savitarnaPrefix}/ntr-paslaugos/seimos-turtas/iregistravimas${this.savitarnaParams}">
                Šeimos turto įregistravimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/seimos-turtas/perkelimas${this.savitarnaParams}">
                Šeimos turto perkėlimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/seimos-turtas/isregistravimas${this.savitarnaParams}">
              Šeimos turto išregistravimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/bendra-nuosavybe/iregistravimas${this.savitarnaParams}">
              Bendrosios jungtinės sutuoktinių nuosavybės įregistravimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/nuomos-sutartis/sudarymas${this.savitarnaParams}">
              Nuomos sutarties sudarymas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/nuomos-sutartis/nutraukimas${this.savitarnaParams}">
              Nuomos sutarties nutraukimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/nuomos-sutartis/isregistravimas${this.savitarnaParams}">
              Nuomos sutarties išregistravimas pasibaigus terminui
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/panaudos-sutartis/sudarymas${this.savitarnaParams}">
              Panaudos sutarties sudarymas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/panaudos-sutartis/nutraukimas${this.savitarnaParams}">
              Panaudos sutarties nutraukimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/panaudos-sutartis/isregistravimas${this.savitarnaParams}">
              Panaudos sutarties išregistravimas pasibaigus terminui
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/subnuomos-sutartis/sudarymas${this.savitarnaParams}">
              Subnuomos sutarties sudarymas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/subnuomos-sutartis/nutraukimas${this.savitarnaParams}">
              Subnuomos sutarties nutraukimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/subnuomos-sutartis/isregistravimas${this.savitarnaParams}">
              Subnuomos sutarties išregistravimas pasibaigus terminui
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/preliminarioji-sutartis/sudarymas${this.savitarnaParams}">
              Preliminarios sutarties sudarymas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/preliminarioji-sutartis/nutraukimas${this.savitarnaParams}">
              Preliminarios sutarties nutraukimas
              </a></li>

              <li><a class="" href="${this.savitarnaPrefix}/ntr-paslaugos/preliminarioji-sutartis/isregistravimas${this.savitarnaParams}">
              Preliminarios sutarties išregistravimas pasibaigus terminui
              </a></li>

              </ul>

                    </li>

            </ul>


            </div>
            <div class="content-info">
              <ul class="path">
                <li>
                  <a href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=1

      ">Pradžia</a>
                </li>
                <li>/</li>
                <li>
                  <a href="

              https://appdevel4.kada.lt/savitarna/goto.do?menuId=7

      ">

      Nekilnojamojo turto kadastras ir registras

                  </a>
                </li>
                <li>/</li>

              </ul>
              <div class="print-top">
                <a href="#" id="menuPrint">Spausdinti</a>
              </div>


            `
    },
    footerData() {
      return `
      <div class="up-bottom">
<a href="#">Į viršų</a>
</div>
<div class="question-bottom">
<a href="http://info.registrucentras.lt/faq/klientu_savitarna"
   target="_blank">
Kilo klausimų?
</a>
</div>
</div>
<div class="clear-float"></div>
</div>
</div>
<div id="footer-in">
<div>
<p class="left" style="width: 24%; "><b>Valstybės įmonė Registrų centras</b><br/>Studentų g. 39, 08106
Vilnius<br/>Tel. +370 5 268 8262<br/>El. p. info@registrucentras.lt<br/>Įmonės kodas 124110246<br/></p>
<p class="left" style="width: 35%; text-align:right !important; padding-right:45px;"><a href="https://appdevel4.kada.lt/bylos/savitarna/REGISTRU_CENTRO_SAVITARNOS_PASLAUGU_TEIKIMO_TAISYKLES.pdf" target="_blank">Savitarnos paslaugų teikimo taisyklės</a><br/><a href="https://appdevel4.kada.lt/bylos/savitarna/SAVITARNOJE_TVARKOMU_ASMENS_DUOMENU_APSAUGOS_APRASAS.pdf" target="_blank">Savitarnoje tvarkomų asmens duomenų apsaugos aprašas</a></p>
<p class="left" style="width: 16%;"><b>Konsultacijų centras</b><br/>Tel. (8 5) 268 8262<br/>Darbo laikas:<br/>I–IV 8.00–17.00 val.<br/>V 8.00–16.00 val.</p>
<p class="left" style="width: 20%; text-align:right !important;"><b>Pagalba ir konsultacijos internetu:</b><br/><a href="http://info.registrucentras.lt/faq/klientu_savitarna" target="_blank">Dažniausiai užduodami klausimai</a><br/><a href="http://info.registrucentras.lt/paklausti" target="_blank">Užduoti klausimą</a><br/><a href="https://www.registrucentras.lt/p/890">Pateikti skundą</a></p>
<p class="left footer-center" style="width: 100%; ">© 2019 Valstybės įmonė Registrų centras. Versija: 3.19.1</p>
</div>
</div>
</div>
<br/>
<!-- Versija:  -->
</body>
</html>
      `
    },
  },
}
